import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

@Injectable()
export class UploadRepresentativeService {

  constructor(private http: Http) { }


  uploadRepresentativeData(formData: FormData){
    return this.http.post('https://api.truevoter.in/True_Voter/uploadRepresentativeExl', formData)
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/upload-representative.service.ts